export const on_boarding_events = {
  onboarding_start_for_free_click: {
    category: "Onboarding",
    action: "User clicks on Start For Free button",
    label: "onboarding-landing-start-click",
  },
  onboarding_log_in_click: {
    category: "Onboarding",
    action: "User clicks on Log In button during onboarding",
    label: "onboarding-landing-log-in-click",
  },

  onboarding_hight_intent_log_in_click: {
    category: "Onboarding",
    action: "User clicks on Log In button during high intent",
    label: "onboarding-high-intent-log-in-click",
  },
  onboarding_home_city_input: {
    category: "Onboarding",
    action: "User enters their home city",
    label: "onboarding-home-city-input-click",
  },
  onboarding_home_city_input_clear: {
    category: "Onboarding",
    action: "When users clears input place field",
    label: "onboarding-home-city-input-clear",
  },
  onboarding_home_city_select_city_click: {
    category: "Onboarding",
    action: "When users select a city in input place field",
    label: "onboarding-home-city-select-city-click",
  },
  onboarding_home_city_next_click: {
    category: "Onboarding",
    action: "User clicks Next after entering home city",
    label: "onboarding-home-city-next-click",
  },
  onboarding_home_city_back_click: {
    category: "Onboarding",
    action: "User clicks Back on home city step",
    label: "onboarding-home-city-back-click",
  },
  onboarding_travel: {
    category: "Onboarding",
    action: "User is on the travel preferences step",
    label: "onboarding-travel",
  },
  onboarding_travel_back_click: {
    category: "Onboarding",
    action: "User clicks Back on travel preferences step",
    label: "onboarding-travel-back-click",
  },
  onboarding_travel_next_click: {
    category: "Onboarding",
    action: "User clicks Next on travel preferences step",
    label: "onboarding-travel-next-click",
  },
  onboarding_vibe: {
    category: "Onboarding",
    action: "User is on the vibe selection step",
    label: "onboarding-vibe",
  },
  onboarding_vibe_back_click: {
    category: "Onboarding",
    action: "User clicks Back on vibe selection step",
    label: "onboarding-vibe-back-click",
  },
  onboarding_vibe_next_click: {
    category: "Onboarding",
    action: "User clicks Next on vibe selection step",
    label: "onboarding-vibe-next-click",
  },
  onboarding_budget: {
    category: "Onboarding",
    action: "User is on the budget selection step",
    label: "onboarding-budget",
  },
  onboarding_budget_back_click: {
    category: "Onboarding",
    action: "User clicks Back on budget selection step",
    label: "onboarding-budget-back-click",
  },
  onboarding_budget_next_click: {
    category: "Onboarding",
    action: "User clicks Next on budget selection step",
    label: "onboarding-budget-next-click",
  },
  // Viral data (Who's coming with you) events
  viral_data_add_traveler_click: {
    category: "Viral Data",
    action: "User clicks add traveler button",
    label: "viral-data-add-traveler-click",
  },
  viral_data_do_it_later_click: {
    category: "Viral Data",
    action: "User clicks I'll do it later",
    label: "viral-data-do-it-later-click",
  },
  viral_data_first_name_input_click: {
    category: "Viral Data",
    action: "User clicks on first name input",
    label: "viral-data-first-name-input-click",
  },
  viral_data_last_name_input_click: {
    category: "Viral Data",
    action: "User clicks on last name input",
    label: "viral-data-last-name-input-click",
  },
  viral_data_email_input_click: {
    category: "Viral Data",
    action: "User clicks on email input",
    label: "viral-data-email-input-click",
  },
  viral_data_remove_traveler_click: {
    category: "Viral Data",
    action: "User removes a traveler",
    label: "viral-data-remove-traveler-click",
  },
  viral_data_accordion_expand: {
    category: "Viral Data",
    action: "User expands traveler accordion",
    label: "viral-data-accordion-expand",
  },
  viral_data_accordion_collapse: {
    category: "Viral Data",
    action: "User collapses traveler accordion",
    label: "viral-data-accordion-collapse",
  },
  viral_data_add_to_trip_click: {
    category: "Viral Data",
    action: "User clicks add them to trip",
    label: "viral-data-add-to-trip-click",
  },
};
